import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "guards/authGuard";
import { SystemproofComponent } from "./system-proof.component";

export enum SYSTEM_PROOF_URLS {
  CAMPAIGNS = "campaigns",
  SYSTEMS = "drivingautomationsystems",
  USECASES = "usecases",
  TESTS_PROTOCOLS = "testprotocols",
}
const routes: Routes = [
  {
    path: "",
    component: SystemproofComponent
  },
  {
    path: SYSTEM_PROOF_URLS.CAMPAIGNS,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./campaign/campaign.module").then((m) => m.CampaignModule),
  },
  {
    path: SYSTEM_PROOF_URLS.USECASES,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./use-case/use-case.module").then((m) => m.UseCaseModule),
  },
  {
    path: SYSTEM_PROOF_URLS.SYSTEMS,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./system/system.module").then((m) => m.SystemModule),
  },
  {
    path: SYSTEM_PROOF_URLS.TESTS_PROTOCOLS,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./test-protocol/test-protocol.module").then((m) => m.TestProtocolModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemProofRoutingModule {}
